import { Scene } from "onearm";
import { FlexContainer } from "onearm";
import { FullScreenBackgroundFill } from "onearm";
import { Signal } from "typed-signals";
export class AutoPlaySettingsScene extends Scene {
    constructor(parameters) {
        super({ ...parameters, name: "AutoPlaySettingsScene", layer: "popups" });

        this.onPressStart = new Signal();
        this.onChangeQuickSpin = new Signal();
        this.onChangeTurboSpin = new Signal();
        this.onChangeSkipScreen = new Signal();
        this.onChangeAutoplayGames = new Signal();
        this.onPressClose = new Signal();

        const {
            screen,
            quickSpin = false,
            turboSpin = false,
            skipScreen = false,
            gamesLimit = 10,
            autoplayGamesMax = 100,
        } = parameters;

        this.fill = this.addChild(
            new FullScreenBackgroundFill({
                fullScreenZone: screen.zone.fullScreen,
                color: 0x000000,
                alpha: 0.8,
            }),
        );
        this.root = this.createObject(FlexContainer, { size: screen.zone.fullScreen });

        this.layout = this.buildLayout("SettingsAutoplayPopup");

        this.connectOnPressSignal(this.onPressStart, "StartAutoplayButton");
        this.connectOnPressSignal(this.onPressClose, "CloseButton");
        this.connectOnChangeSignal(this.onChangeQuickSpin, "QuickSpinToggle");
        this.connectOnChangeSignal(this.onChangeTurboSpin, "TurboSpinToggle");
        this.connectOnChangeSignal(this.onChangeSkipScreen, "SkipScreenToggle");

        this.layout.forAll("ValueSlider", (slider) => {
            slider.onUpdate.connect(value => {
                this.updateStartAutoplayText(value);
            });
            slider.onChange.connect((value) => this.onChangeAutoplayGames.emit(value));
            slider.setSteps({
                    min: 1,
                    max: autoplayGamesMax,
                    step: 1,
                },
                gamesLimit,
            );
        });

        this.layout.forAll("QuickSpinToggle", (toggle) => toggle.setState(quickSpin));
        this.layout.forAll("TurboSpinToggle", (toggle) => toggle.setState(turboSpin));
        this.layout.forAll("SkipScreenToggle", (toggle) => toggle.setState(skipScreen));

        this.updateStartAutoplayText(gamesLimit);
    }

    setQuickSpin(value) {
        this.layout.forAll("QuickSpinToggle", (toggle) => toggle.setState(value));
    }

    setTurboSpin(value) {
        this.layout.forAll("TurboSpinToggle", (toggle) => toggle.setState(value));
    }

    connectOnPressSignal(signal, btnName) {
        this.layout.forAll(btnName, (btn) => {
            btn.onPress.connect(signal instanceof Signal ? (v) => signal.emit(v) : signal.bind(this));
        });
    }

    connectOnChangeSignal(signal, btnName) {
        this.layout.forAll(btnName, (btn) => {
            btn.onChange.connect(signal instanceof Signal ? (v) => signal.emit(v) : signal.bind(this));
        });
    }

    updateStartAutoplayText(value) {
        this.layout.forAll("StartAutoplayText", (text) => {
            text.text = `START AUTOPLAY (${value})`;
        });
        this.layout.forAll("ValueSlider", (slider) => {
            slider.value = value;
        });
    }
}
